module.exports = __webpack_public_path__ + "static/media/chill-spins-1024x458-transparent.d106c77b.png";